import { __decorate, __metadata } from "tslib";
import { IdItemModel, Trim, Expose, ItemModelProp, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { ReferrerRestraints } from "./referrer.restraints";
import { CrudRequestType } from '@core/shared/request';
let ReferrerItem = /*#__PURE__*/(() => {
  let ReferrerItem = class ReferrerItem extends IdItemModel {
    // Alias | optional | Most items have a name to make them identifyable by humans.
    // @Expose()
    // @ItemModelProp({defaultValueCreate:''})
    // alias:string;
    toString() {
      return "Referrer " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], ReferrerItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ReferrerItem.prototype, "updateDate", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ReferrerItem.prototype, "referrerId", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], ReferrerItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], ReferrerItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), Trim(), __metadata("design:type", String)], ReferrerItem.prototype, "referrerCode", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], ReferrerItem.prototype, "notes", void 0);
  ReferrerItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true,
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/users/referrers'
  }, {
    clientCache: {
      seconds: 15 * 60,
      clearOnUserChange: true,
      endpoints: {
        public: true,
        admin: [CrudRequestType.ReadMany]
      }
    }
  }), ItemModelDefinition({
    texts: {
      item: 'Referrer',
      items: 'Referrer'
    }
  }), UseRestraints(ReferrerRestraints), ModelId("ReferrerItem") // auto-generated by generate-model-ids
  ], ReferrerItem);
  return ReferrerItem;
})();
export { ReferrerItem };